<div class="logo" [ngClass]="customClass">
  <figure class="m-0" [ngClass]="{'fullLogo': variant === 'full'}">
    <!-- <img [src]="isDarkMode ? 
    'assets/images/logo/FinanceLogix_LOGO@2x.png':
    'assets/images/logo/FinanceLogix_LOGO@2x.png'" alt="Finance Logic"> -->
    <!-- <img *ngIf="variant === 'mini'" src="assets/images/logo/logo.png" alt="Finance Logic Icon" /> -->
    <img [src]="logoSrc" alt="">
  </figure>
</div>